import React from "react";
import { useTheme } from "styled-components";

const Button = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5.063h7.219a.72.72 0 0 1 .464.164.53.53 0 0 1 .192.398v6.75c0 .15-.07.292-.192.398a.72.72 0 0 1-.464.165H9m0 0H1.781a.72.72 0 0 1-.464-.165.53.53 0 0 1-.192-.398v-6.75c0-.15.07-.292.192-.398a.72.72 0 0 1 .464-.165H9"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 9h9"
        stroke={theme.text.text}
        stroke-width="1.125"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default Button;
